/* jshint esversion: 6 */
import $ from 'jquery';

export default function Serialize(form) {
  if (form) return $(form).serialize();

  return '';
}
